import { refreshOutdatedTranslations } from './translationService';

const bootstrapApplication = async () => {
  Promise.all([refreshOutdatedTranslations()])
    .then(() => {
      return true;
    })
    .catch(() => {
      return false;
    });
};

export default bootstrapApplication;
